// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pyZxA","footerLogos":"Footer_footerLogos__zVeEc","footerLogo":"Footer_footerLogo__wzkhq"};